"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _fontIcon = _interopRequireDefault(require("../font-icon"));

var _content = _interopRequireDefault(require("../content"));

var _stack = _interopRequireDefault(require("../../molecules/stack"));

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          padding: 4px 12px;\n          border: 1px solid #969aa3;\n          border-radius: 2px;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  cursor: pointer;\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  height: 25px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var handleSelectedFiles = function handleSelectedFiles(event, props) {
  var inputFileArray = []; // Files - array of selected files.

  var files = event.target.files;

  for (var i = 0; i < files.length; i += 1) {
    var file = files[i];
    inputFileArray.push(file);
  }

  props.onSelection(inputFileArray);
  event.stopPropagation();
};

var AttachmentMessage = function AttachmentMessage(props) {
  return _react["default"].createElement(_stack["default"], {
    widths: [5, 95]
  }, _react["default"].createElement(_fontIcon["default"], {
    size: props.size
  }, props.icon), _react["default"].createElement(_content["default"], {
    size: 3,
    color: props.messageColor
  }, props.message));
};

var Attachment = function Attachment(props) {
  return _react["default"].createElement("div", null, _react["default"].createElement(Attachment.Input, {
    type: "file",
    name: "file",
    id: "file",
    multiple: props.multiple,
    onChange: function onChange(event) {
      return handleSelectedFiles(event, props);
    }
  }), _react["default"].createElement(Attachment.Content, {
    htmlFor: "file",
    bordered: props.bordered
  }, _react["default"].createElement(AttachmentMessage, props)));
};

Attachment.Input = _styledComponents["default"].input(_templateObject());
Attachment.Content = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.bordered ? (0, _styledComponents.css)(_templateObject3()) : null;
});
Attachment.propTypes = {
  /** Attachment size */
  size: _propTypes["default"].number,

  /** Attachment icon */
  icon: _propTypes["default"].string,

  /** Attachment message */
  message: _propTypes["default"].string,

  /** Render a border */
  bordered: _propTypes["default"].bool,

  /** Attachment message color */
  messageColor: _propTypes["default"].string,

  /** This function will return the attached files in array */
  onSelection: _propTypes["default"].func,

  /** Enable multiple selection */
  multiple: _propTypes["default"].bool
};
Attachment.defaultProps = {
  size: '20',
  icon: 'icon-attach1',
  message: 'Attach from local folder',
  bordered: false,
  messageColor: 'dodgerBlue',
  multiple: false,
  onSelection: _noop2["default"]
};
Attachment.displayName = 'Attachment';

var _default = (0, _context.withVersion)(Attachment);

exports["default"] = _default;